// extracted by mini-css-extract-plugin
export var banner = "eu-program-banner-module--banner--lDmvd";
export var content = "eu-program-banner-module--content--2H4c4";
export var details = "eu-program-banner-module--details---gDVc";
export var inner = "eu-program-banner-module--inner--0J+9M";
export var logoEu = "eu-program-banner-module--logo-eu--mZqYt";
export var logoProgram = "eu-program-banner-module--logo-program--MnlG4";
export var text = "eu-program-banner-module--text--lACSs";
export var wrapper = "eu-program-banner-module--wrapper--h4KXQ";